export default __webpack_public_path__ + "static/media/right-tick.22e42265.svg";